import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../base.component";
import {UserService} from "../common/user.service";
import {IShopUser} from "../session/customer-models";
import {Constants} from "../constants";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {LoggerService} from "../common/logger.service";
import {NavigationService} from "../common/navigation.service";
import {TranslateService} from "../translation/translate.service";
import {LocaleUtil} from "../util/locale-util";

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    animations: [
        trigger('fadeInFooter', [
            state('shown', style({
                opacity: 1
            })),
            state('hidden', style({
                opacity: 0
            })),
            transition('hidden => shown', animate('.5s'))
        ])
    ],
    standalone: false
})
export class FooterComponent extends BaseComponent implements OnInit{

    showFooter: boolean = false;
    showJpFooterLink: boolean = false;
    showFdaDisclaimer: boolean = false;
    showLegalDisclaimer: boolean = false;
    showTermsAndConditions: boolean = false;
    showDmca: boolean = false;
    recaptchaMobileFooterMessage: string;
    privacyPolicyUrl: string;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private navigationService: NavigationService,
        private translateService: TranslateService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.delayedShowFooter();
        this.setFooterDisplay();

        this.navigationService.navigationStartSubject.watch().subscribe(() => {
            this.showFooter = false;
            this.delayedShowFooter();
        });

        this.translateService.translateRequest({
            tag: 'cart.footer.recaptcha.message',
            replacements: new Map([['privacyUrl', Constants.RECAPTCHA_PRIVACY], ['termsUrl', Constants.RECAPTCHA_TERMS]])
        }).then(translatedValue => this.recaptchaMobileFooterMessage = translatedValue);
    }

    private delayedShowFooter() {
        setTimeout(()=>{
            this.showFooter = true;
        }, 1500);
    }

    private setFooterDisplay() {
        this.getCustomerData().then((user: IShopUser) => {
            this.showJpFooterLink = user.currentCountry == Constants.COUNTRY_JP;
            this.showFdaDisclaimer = user.currentCountry == Constants.COUNTRY_US;
            this.showLegalDisclaimer = user.currentCountry == Constants.COUNTRY_KR;
            this.privacyPolicyUrl = `${Constants.URL_DOTCOM}/${LocaleUtil.getUrlLocale(user.teasLocale || user.usanaLocale)}/document/Privacy_Policy`;

            if (!this.limitedShopping) {
                this.showTermsAndConditions = true;
                this.showDmca = true;
            }
        });
    }
}
